import { Heading } from 'components/1-atoms/Heading';
import { CatalogList } from 'components/2-molecules/CatalogList';
import { CatalogListItemProps } from 'components/2-molecules/CatalogListItem';
import styles from './RelatedList.module.scss';
export interface RelatedListProps {
	heading: string;
	items: CatalogListItemProps[];
}

export const RelatedList: React.FC<RelatedListProps> = ({ heading, items }) => {
	return (
		<div className={styles.RelatedList}>
			<Heading className={styles.RelatedList_heading} headingLevel="h2" style="md">
				{heading}
			</Heading>
			<CatalogList items={items} />
		</div>
	);
};
